var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStep5Active(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 54,
    viewBox: "0 0 53 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9344_8358)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 2,
    width: 41,
    height: 41,
    rx: 5.5,
    stroke: "#333333",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1304 13.5L17.9504 13.68L17.5904 21.4208C17.71 21.6265 17.8945 21.8189 18.1438 21.9989C18.3921 22.1789 18.6358 22.2862 18.8762 22.3209C19.3391 21.9173 19.8188 21.6277 20.3164 21.4532C20.8139 21.2788 21.2936 21.1905 21.7565 21.1905C22.2015 21.1905 22.6052 21.2553 22.9652 21.3839C23.3252 21.5136 23.664 21.7149 23.9816 21.9899C24.298 22.2661 24.5384 22.6183 24.7017 23.0488C24.8649 23.4782 24.9465 23.9947 24.9465 24.5974C24.9465 25.7502 24.6335 26.6581 24.0084 27.32C23.3823 27.9831 22.5716 28.3141 21.5776 28.3141C21.0633 28.3141 20.5143 28.2157 19.9317 28.0189C19.3492 27.821 18.7487 27.5079 18.1315 27.0796C17.8744 27.2675 17.634 27.5381 17.4115 27.8903C17.189 28.2425 17.0514 28.5634 17 28.8541C18.2512 29.951 19.8635 30.5 21.8348 30.5C22.6231 30.5 23.3778 30.3625 24.0979 30.0896C24.8179 29.8146 25.443 29.4244 25.9752 28.919C26.5063 28.4136 26.9301 27.7997 27.2487 27.0796C27.5652 26.3596 27.724 25.5534 27.724 24.6623C27.724 22.8453 27.2521 21.4599 26.3095 20.5084C25.3669 19.5569 24.0979 19.0817 22.5034 19.0817C21.7319 19.0817 20.9772 19.236 20.2403 19.5446L20.4203 17.0758V15.7899H25.8466C26.6349 15.7899 27.0285 15.3952 27.0285 14.6069C27.0285 14.2122 26.9692 13.8444 26.8496 13.5011H18.1304V13.5Z",
    fill: "#333333"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9344_8358"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 53,
    height: 53,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep5Active);
export default __webpack_public_path__ + "static/media/step5-active.f70cb589e32fd919864e9fe2f38bbe1f.svg";
export { ForwardRef as ReactComponent };